module.exports = __webpack_public_path__ + "img/kdg.bc1bcdae.jpg";